import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import Home from "./pages/Home"; 
import Contact from "./pages/Contact";
import Projects from "./pages/Projects";
import "./App.css";

function App() {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <Router>
      <div className="app" style={{
        background: `
          radial-gradient(circle, rgba(255, 255, 255, 0.2) 10%, transparent 50%),
          linear-gradient(135deg, rgba(211, 211, 211, 0.8), rgba(43, 43, 43, 0.9))
        `,
        minHeight: '100vh',
        position: 'relative',
      }}>
        <Particles
          id="tsparticles"
          init={particlesInit}
          options={{
            background: {
              color: {
                value: "transparent",
              },
            },
            fpsLimit: 120,
            particles: {
              color: {
                value: "#ffcc00", // Gold particles
              },
              links: {
                color: "#ffcc00", // Gold links
                distance: 150,
                enable: true,
                opacity: 0.5,
                width: 1.5,
              },
              collisions: {
                enable: false,
              },
              move: {
                enable: true,
                direction: "none",
                outModes: {
                  default: "bounce",
                },
                random: false,
                speed: 2, // Increased speed
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                  area: 800,
                },
                value: 60, // Reduced for better performance
              },
              opacity: {
                value: 0.7,
              },
              shape: {
                type: "circle",
              },
              size: {
                value: { min: 1, max: 3 },
              },
            },
            detectRetina: true,
          }}
          style={{
            position: "fixed",
            zIndex: 0,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        />
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projects" element={<Projects />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
